import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { ERoutePaths } from 'libraries/router/types'
import { MdiArrowIcon } from 'assets'

import styles from './Breadcrumb.module.scss'

interface BreadcrumbProps {
  routes: { label: string; link?: string; Icon?: any }[]
  className?: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ routes, className }) => {
  const navigate = useNavigate()

  const defaultRoutes = [
    {
      label: 'Назад',
      link: -1,
      Icon: <MdiArrowIcon />,
    },
    {
      label: 'Головна',
      link: ERoutePaths.Home,
    },
  ]

  const routesList = [...defaultRoutes, ...routes]

  return (
    <nav aria-label='breadcrumb' className={className}>
      <ol className={styles.wrapper}>
        {routesList.map(({ label, link, Icon }, index) => (
          <li key={index} className={styles.wrapper__item}>
            {Icon}
            {link ? (
              <>
                {typeof link === 'string' ? (
                  <Link className={styles.label} to={link}>
                    {label}
                  </Link>
                ) : (
                  <span className={styles.label} onClick={() => navigate(link)}>
                    {label}
                  </span>
                )}
              </>
            ) : (
              <span className={styles.label}>{label}</span>
            )}{' '}
            {routesList.length - 1 !== index && <span> / </span>}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumb
